var map = {
	"./en.json": [
		63246,
		63246
	],
	"./pt.json": [
		40781,
		40781
	],
	"./ru.json": [
		50920,
		50920
	],
	"./sp.json": [
		33010,
		33010
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 95426;
module.exports = webpackAsyncContext;